import { render } from "./SystemTabPresencas.vue?vue&type=template&id=11e26a46&scoped=true&ts=true"
import script from "./SystemTabPresencas.vue?vue&type=script&lang=ts"
export * from "./SystemTabPresencas.vue?vue&type=script&lang=ts"

import "./SystemTabPresencas.vue?vue&type=style&index=0&id=11e26a46&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e26a46"]])

export default __exports__